// src/modules/step-table.ts
/**
 * Fleming VARK 官方 step-value 查表
 * 来源:VARK Manual (vark-learn.com), Fleming 2001
 */
export function stepValueFor(total: number): number {
  if (typeof total !== 'number' || total < 0) {
    throw new Error(`invalid total: ${total}`);
  }
  if (total <= 16) return 1;
  if (total <= 22) return 2;
  if (total <= 26) return 3;
  if (total <= 32) return 4;
  return 5;
}
